module.exports = __webpack_public_path__ + "static/hero-present-intro-desktop-955a7730cb4b9bed5283f2018c54f2ea.mp4";